var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"",attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex flex-row flex-wrap tw-w-full tw-px-3 tw-mx-auto"},_vm._l((6),function(item){return _c('div',{key:item.id,staticClass:"tw-w-1/3 px-2 py-2"},[_c('kubiqa-website-themes-theme-d-components-shared-listing-card')],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }